import { handleActions } from "redux-actions";
import {
  FETCH_CURRENT_USER_SUCCESS,
  SET_LOADING,
  SET_UPDATES_LOADING,
  FETCH_TABLE_SUCCESS,
  SET_DATE,
  SET_TOGGLE,
  SET_VIEW,
  SET_RISK_LEVELS
} from "./RiskMembersSagas";

export const VIEWS = {
  BY_VISITS: "by_visits",
  BY_PREDICTION: "by_prediction"
};

export const RISK_LEVELS = ["critical", "high", "medium", "low"];

export const initialState = {
  currentUser: {},
  initialRequest: false,
  isLoading: false,
  updatesLoading: false,
  date: "",
  table: {},
  scorecards: [],
  includeFutureVisits: true,
  view: VIEWS.BY_PREDICTION,
  riskLevels: ["critical"]
};

export default handleActions(
  {
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [SET_DATE]: (state, action) => ({
      ...state,
      date: action.payload
    }),
    [SET_UPDATES_LOADING]: (state, action) => ({
      ...state,
      updatesLoading: action.payload
    }),
    [FETCH_CURRENT_USER_SUCCESS]: (state, action) => ({
      ...state,
      currentUser: action.payload,
      initialRequest: true
    }),
    [FETCH_TABLE_SUCCESS]: (state, action) => ({
      ...state,
      table: action.payload,
      scorecards: action.payload.chart_values || []
    }),
    [SET_TOGGLE]: (state, action) => ({
      ...state,
      includeFutureVisits: action.payload
    }),
    [SET_VIEW]: (state, action) => ({
      ...state,
      view: action.payload
    }),
    [SET_RISK_LEVELS]: (state, action) => ({
      ...state,
      riskLevels: action.payload
    })
  },

  initialState
);
